import { TypedUseSelectorHook, useSelector } from "react-redux";
import { AuthState } from "./AuthReducer";
import { AppState } from "@grassrootly/rn-core";

const useAuthSelector: TypedUseSelectorHook<{ auth: AuthState } & AppState> = useSelector;

export const useUser = () => useAuthSelector(({ auth }) => auth.user);
